import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IVehicleData } from '../../../../../core/models/vehicle-data.model';
import { getVehicleTypeOptions, getFuelTypeOptions } from '../../../../../core/utils/vehicle-utils';
import { LoaderService } from '../../../../../core/services/loader.service';
import { StepKey } from '../../../../../core/enums/stepper.enum';
import { FunnelService } from '../funnel.service';
import { FuelType } from '../../../../../core/enums/fuel-type.enum';
import { VehicleType } from '../../../../../core/enums/vehicle-type.enum';
import { tap, finalize } from 'rxjs/operators';
import { FuelTypeTranslations } from '../../../../../core/utils/fuel-dictionary';
import { VehicleTypeTranslations } from '../../../../../core/utils/vehicle-type-dictionary';
import { SharedStateService } from '../../../../../core/services/first-layer.service';

@Component({
  selector: 'app-vehicle-data',
  standalone: false,
  templateUrl: './vehicle-data.component.html',
  styleUrl: './vehicle-data.component.scss',
})

export class VehicleDataComponent {

  validationState = {
    licensePlate: false,
    brand: false,
    model: false,
    fuelType: false,
    vehicleType: false,
  };

  vehicleDataFromApi: any | null = null;
  showVehicleCard = false;
  
  vehicleTypeOptions = getVehicleTypeOptions();
  fuelTypeOptions = getFuelTypeOptions();
  @Output() vehicleDataCompleted = new EventEmitter<IVehicleData>();
  @Output() stepActivated = new EventEmitter<StepKey>();
  @Input() form!: FormGroup;
  showManualForm = false;
  vehicleData: IVehicleData = {} as IVehicleData;
  licensePlateNotFound = false;
  licensePlateMandatory = false;
  licensePlate: string = '';
  isOpen = false;
  selectedLabel: string | null = null;
  showValidationErrors = false;

  constructor(private loader: LoaderService, private funnelService: FunnelService, private loaderService: LoaderService,
    private stateService: SharedStateService
  ) {

  }

  ngOnInit() {
    this.stateService.setShowManualForm(false);
    this.stepActivated.emit(StepKey.Vehicle);

    const stored = localStorage.getItem('vehicleData');
    if (stored) {
      const parsed = JSON.parse(stored);
      this.form.patchValue(parsed);
    }
  }

  toggleManualForm(): void {
    this.showManualForm = !this.showManualForm;
    this.stateService.setShowManualForm(this.showManualForm);
    if (this.showManualForm) {
      this.showVehicleCard = false;
    } else if (!this.showManualForm) {
      this.showVehicleCard = true;
    }
  }
  
  get readableFuelType(): string {
    const fuelType = this.vehicleDataFromApi?.FuelType as FuelType;
    return fuelType ? FuelTypeTranslations[fuelType] || 'Desconocido' : 'Desconocido';
  }
  
  get readableVehicleType(): string {
    const vehicleType = this.vehicleDataFromApi?.ChassisType as VehicleType;
    console.log('VehicleType recibido:', vehicleType);
    return vehicleType ? VehicleTypeTranslations[vehicleType] || 'Desconocido' : 'Desconocido';
  }  

    searchByLicensePlate() {
      this.licensePlate = this.form.get('licensePlate')?.value?.toUpperCase();
      if (!this.licensePlate) {
        this.licensePlateNotFound = false;
        this.licensePlateMandatory = true;
        return;
      }

      this.loaderService.show();
      this.funnelService.getVehicleData(this.licensePlate).pipe(
        finalize(() => this.loaderService.hide()),
      ).subscribe({
        next: (data: any) => {
          this.vehicleDataFromApi = data;
          this.showVehicleCard = true;
          this.licensePlateNotFound = false;
          this.licensePlateMandatory = false;

          this.form.patchValue({
            vehicleType: data.ChassisType,
            brand: data.Brand,
            model: data.Model,
            fuelType: data.FuelType,
            licensePlate: data.LicensePlate,
          });

        },
        error: (err: any) => {
          this.licensePlateMandatory = false;
          this.licensePlateNotFound = true;
          this.showValidationErrors = true;
          this.vehicleDataFromApi = null;
          this.showVehicleCard = false;
        }
      });
    }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  onVehicleTypeSelected(option: any) {
    this.isOpen = false;
    this.form.get('vehicleType')?.setValue(option.value);
  }

  onFuelTypeSelected(option: any) {
    this.isOpen = false;
    this.form.get('fuelType')?.setValue(option.value);
  }

  handleNext() {
    const controls = this.form.controls;
  
    Object.keys(controls).forEach((key) => {
      const typedKey = key as keyof typeof this.validationState;
  
      if (this.validationState.hasOwnProperty(typedKey)) {
        const control = controls[key];
        this.validationState[typedKey] = control.invalid;
        control.markAsTouched();
      }
    });

    if (this.form.invalid) {
      console.warn('Formulario inválido');
      return;
    }
    this.stateService.setShowManualForm(true);
    this.vehicleDataCompleted.emit(this.form.value);

  }
  
}
